import React from "react"
import { BrowserRouter as Router } from "react-router-dom"

import { Providers } from "Providers"
import { Routes } from "features/navigation"
import { AppStyles } from "App.styles"
import moment from "moment"

const App = () => {
  moment.locale("fr")
  return (
    <Router>
      <Providers>
        <AppStyles/>
        <Routes/>
      </Providers>
    </Router>
  )
}

export default App
